export const SET_DESTRUCTIVE_ACTION_PENDING = 'SET_DESTRUCTIVE_ACTION_PENDING';
export const SET_PENDING_DESTRUCTIVE_NAVIGATION =
  'SET_PENDING_DESTRUCTIVE_NAVIGATION';

/**
 * Set whether a destructive action is pending on the current page.
 * Pages with destructive modals set this flag so external features
 * (e.g., side nav) can intercept navigation.
 * @param {boolean} pending - True when the current page has destructive data
 * and external navigation should be intercepted; false to clear the flag.
 */
export const setDestructiveActionPending = pending => ({
  type: SET_DESTRUCTIVE_ACTION_PENDING,
  pending,
});

/**
 * Store a URL that an external navigator (e.g., side nav) wants to
 * reach. The page's useDestructiveConfirmation hook watches this
 * value and opens the destructive modal when it becomes non-null.
 * @param {Object} [params={}] - Deferred navigation payload.
 * @param {string|null} [params.url=null] - Deferred destination path requested
 * by external navigation (for example, side nav). Use null to clear pending
 * navigation.
 * @param {string|null} [params.origin=null] - Source of the deferred trigger
 * (for example, 'sidenav' or 'continue'). Use null when clearing state.
 */
export const setPendingDestructiveNavigation = ({
  url = null,
  origin = null,
} = {}) => ({
  type: SET_PENDING_DESTRUCTIVE_NAVIGATION,
  url,
  origin,
});
